<div class="event-types-container">
  <div class="row justify-content-between">
    <div class="col-4">
      <div class="md-form w-100 mr-2 environment-search">
        <input
          class="form-control"
          id="search"
          type="search"
          mdbInput
          [(ngModel)]="environmentsSearchText"
        />
        <label for="search">Search Environments</label>
      </div>
    </div>
    <div class="col-3">
      <div class="btn-spacing text-right">
        <button
          class="theme-modal-button btn"
          type="button"
          mdbBtnp
          mdbWavesEffect
          (click)="manageEnvironment('add')"
        >
          <mdb-icon far icon="plus-square" class="pr-1"></mdb-icon>
          Add Environment
        </button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12" *ngIf="!environmentsLoading">
      <div class="card-group">
        <div
          *ngFor="
            let environment of environments
              | filter : environmentsSearchText;
            let i = index
          "
        >
          <mdb-card>
            <mdb-card-body>
              <mdb-card-title>
                <h5 class="mb-3">{{ environment.label }}</h5>
              </mdb-card-title>
              <mdb-card-text class="mb-0">
                <ul class="list-unstyled">
                  <li>
                    {{ environment.description }}
                  </li>
                </ul>
              </mdb-card-text>
            </mdb-card-body>
            <mdb-card-footer class="modal-footer">
              <a
                (click)="manageEnvironment('edit', i, environment)"
                mdbTooltip="Edit"
                placement="top"
              >
                <mdb-icon far icon="edit"></mdb-icon>
              </a>
              <a
                (click)="archiveEnvironment(environment)"
                mdbTooltip="Archive"
                placement="top"
              >
                <mdb-icon fas icon="archive"></mdb-icon>
              </a>
            </mdb-card-footer>
          </mdb-card>
        </div>
      </div>
    </div>
  </div>
</div>
